export var StorageKey;
(function (StorageKey) {
    StorageKey["extra"] = "extra";
    StorageKey["stacks"] = "stacks";
})(StorageKey || (StorageKey = {}));
